module.exports = __webpack_public_path__ + "img/02.7407a1a0.jpg";